module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 41
// module chunks = 1